import React from "react";
import { Box, CardMedia } from "@mui/material";

const Header = () => {
  return (
    <Box
      sx={{
        mx: "auto",
        width: 300,
      }}
    >
      <CardMedia
        sx={{
          height: 128,
          width: 128,
          mt: 7.5, // 60px / 8px = 7.5
          mx: "auto",
        }}
        image="/images/logo_gray.png"
        title="Skillzminer"
      />
    </Box>
  );
}

export default Header;
